import React from 'react';
import { Space } from 'antd';
import shopee from 'assets/images/integrations/listview/shopee.png';
import shopify from 'assets/images/integrations/listview/shopify.png';
import mailchimp from 'assets/images/integrations/listview/mailchimp.png';
import googleAnalytics from 'assets/images/integrations/listview/googleAnalytics.png';
import amazon from 'assets/images/integrations/listview/amazon.png';
import blibli from 'assets/images/integrations/listview/blibli.png';
import bukalapak from 'assets/images/integrations/listview/bukalapak.png';
import delhivery from 'assets/images/integrations/listview/delhivery.png';
import eBay from 'assets/images/integrations/listview/ebay.png';
import elevenStreet from 'assets/images/integrations/listview/elevenStreet.png';
import etsy from 'assets/images/integrations/listview/etsy.png';
import facebookAds from 'assets/images/integrations/listview/facebookAds.png';
import amazonAds from 'assets/images/integrations/listview/amazonAds.png';
import flipkart from 'assets/images/integrations/listview/flipkart.png';
import googleAds from 'assets/images/integrations/listview/googleAds.png';
import googleSearchConsole from 'assets/images/integrations/listview/googleSearchConsole.png';
import jd from 'assets/images/integrations/listview/jd.png';
import lazada from 'assets/images/integrations/listview/lazada.png';
import lighthouse from 'assets/images/integrations/listview/lighthouse.png';
import magento from 'assets/images/integrations/listview/magento.png';
import myntra from 'assets/images/integrations/listview/myntra.png';
import prestaShop from 'assets/images/integrations/listview/prestaShop.png';
import qoo10 from 'assets/images/integrations/listview/qoo10.png';
import salesforce from 'assets/images/integrations/listview/salesforce.png';
import semrush from 'assets/images/integrations/listview/semrush.png';
import shiprocket from 'assets/images/integrations/listview/shiprocket.png';
import singPost from 'assets/images/integrations/listview/singPost.png';
import tiki from 'assets/images/integrations/listview/tiki.png';
import tiktok from 'assets/images/integrations/listview/tiktok.png';
import tokopedia from 'assets/images/integrations/listview/tokopedia.png';
import tokopediaShop from 'assets/images/integrations/listview/tokopediaShop.png';
import wooCommerce from 'assets/images/integrations/listview/wooCommerce.png';
import zalora from 'assets/images/integrations/listview/zalora.png';
import jtExpress from 'assets/images/integrations/listview/jtExpress.png';
import MyStock from 'assets/images/integrations/listview/MyStock.png';
import netSuite from 'assets/images/integrations/listview/netSuite.png';
import odoo from 'assets/images/integrations/listview/odoo.png';
import offline from 'assets/images/integrations/listview/offline.png';
import sap from 'assets/images/integrations/listview/sap.png';
import satsaco from 'assets/images/integrations/listview/satsaco.png';
import SiAWMS from 'assets/images/integrations/listview/SiAWMS.png';
import vend from 'assets/images/integrations/listview/vend.png';
import ych from 'assets/images/integrations/listview/ych.png';
import aramex from 'assets/images/integrations/listview/aramex.png';
import aramexShipping from 'assets/images/integrations/listview/aramexShipping.png';
import customWMS from 'assets/images/integrations/listview/customWMS.png';
import customERP from 'assets/images/integrations/listview/customERP.png';
import eccang from 'assets/images/integrations/listview/eccang.png';
import infor from 'assets/images/integrations/listview/infor.png';
import janio from 'assets/images/integrations/listview/janio.png';
import ninjaVan from 'assets/images/integrations/listview/ninjaVan.png';
import cityLink from 'assets/images/integrations/listview/cityLink.png';
import easyEcom from 'assets/images/integrations/listview/easyEcom.png';
import flow from 'assets/images/integrations/listview/flow.png';
import shopeeGlobal from 'assets/images/integrations/listview/shopeeGlobal.png';
import ajio from 'assets/images/integrations/listview/ajio.png';
import tiktokAds from 'assets/images/integrations/listview/tiktokAds.png';
import lazadaGlobal from 'assets/images/integrations/listview/Lazada-global.png';
import zaloraGlobal from 'assets/images/integrations/listview/zalora-global.png';
import amazonVendorCentral from 'assets/images/integrations/listview/amazonVendorCentral.png';
import unicommerce from 'assets/images/integrations/listview/unicommerce.png';
import lazada_chat from 'assets/images/integrations/listview/lazada_chat.png';
import shopee_chat from 'assets/images/integrations/listview/shopee_chat.png';
import tokopedia_chat from 'assets/images/integrations/listview/tokopedia_chat.png';
import myntraSjit from 'assets/images/integrations/listview/myntraSjit.png';
import zepto from 'assets/images/integrations/listview/zepto.png';
import instamart from 'assets/images/integrations/listview/instamart.png';
import blinkit from 'assets/images/integrations/listview/blinkit.png';
import meesho from 'assets/images/integrations/listview/meesho.png';
import tataCliq from 'assets/images/integrations/listview/tatacliq.png';
import spx from 'assets/images/integrations/listview/spx.png';

import shopeeGrid from 'assets/images/integrations/gridview/shopee.png';
import shopifyGrid from 'assets/images/integrations/gridview/shopify.png';
import mailchimpGrid from 'assets/images/integrations/gridview/mailchimp.png';
import googleAnalyticsGrid from 'assets/images/integrations/gridview/googleAnalytics.png';
import amazonGrid from 'assets/images/integrations/gridview/amazon.png';
import blibliGrid from 'assets/images/integrations/gridview/blibli.png';
import bukalapakGrid from 'assets/images/integrations/gridview/bukalapak.png';
import delhiveryGrid from 'assets/images/integrations/gridview/delhivery.png';
import eBayGrid from 'assets/images/integrations/gridview/ebay.png';
import elevenStreetGrid from 'assets/images/integrations/gridview/elevenStreet.png';
import etsyGrid from 'assets/images/integrations/gridview/etsy.png';
import facebookAdsGrid from 'assets/images/integrations/gridview/facebookAds.png';
import amazonAdsGrid from 'assets/images/integrations/gridview/amazonAds.png';
import flipkartGrid from 'assets/images/integrations/gridview/flipkart.png';
import googleAdsGrid from 'assets/images/integrations/gridview/googleAds.png';
import googleSearchConsoleGrid from 'assets/images/integrations/gridview/googleSearchConsole.png';
import jdGrid from 'assets/images/integrations/gridview/jd.png';
import lazadaGrid from 'assets/images/integrations/gridview/lazada.png';
import lighthouseGrid from 'assets/images/integrations/gridview/lighthouse.png';
import magentoGrid from 'assets/images/integrations/gridview/magento.png';
import myntraGrid from 'assets/images/integrations/gridview/myntra.png';
import prestaShopGrid from 'assets/images/integrations/gridview/prestaShop.png';
import qoo10Grid from 'assets/images/integrations/gridview/qoo10.png';
import salesforceGrid from 'assets/images/integrations/gridview/salesforce.png';
import semrushGrid from 'assets/images/integrations/gridview/semrush.png';
import shiprocketGrid from 'assets/images/integrations/gridview/shiprocket.png';
import singPostGrid from 'assets/images/integrations/gridview/singPost.png';
import tikiGrid from 'assets/images/integrations/gridview/tiki.png';
import tiktokGrid from 'assets/images/integrations/gridview/tiktok.png';
import tokopediaGrid from 'assets/images/integrations/gridview/tokopedia.png';
import tokopediaShopGrid from 'assets/images/integrations/gridview/tokopediaShop.png';
import wooCommerceGrid from 'assets/images/integrations/gridview/wooCommerce.png';
import zaloraGrid from 'assets/images/integrations/gridview/zalora.png';
import jtExpressGrid from 'assets/images/integrations/gridview/jtExpress.png';
import MyStockGrid from 'assets/images/integrations/gridview/MyStock.png';
import netSuiteGrid from 'assets/images/integrations/gridview/netSuite.png';
import odooGrid from 'assets/images/integrations/gridview/odoo.png';
import offlineGrid from 'assets/images/integrations/gridview/offline.png';
import sapGrid from 'assets/images/integrations/gridview/sap.png';
import satsacoGrid from 'assets/images/integrations/gridview/satsaco.png';
import SiAWMSGrid from 'assets/images/integrations/gridview/SiAWMS.png';
import vendGrid from 'assets/images/integrations/gridview/vend.png';
import ychGrid from 'assets/images/integrations/gridview/ych.png';
import aramexGrid from 'assets/images/integrations/gridview/aramex.png';
import aramexShippingGrid from 'assets/images/integrations/gridview/aramexShipping.png';
import customWMSGrid from 'assets/images/integrations/gridview/customWMS.png';
import customERPGrid from 'assets/images/integrations/gridview/customERP.png';
import eccangGrid from 'assets/images/integrations/gridview/eccang.png';
import inforGrid from 'assets/images/integrations/gridview/infor.png';
import janioGrid from 'assets/images/integrations/gridview/janio.png';
import ninjaVanGrid from 'assets/images/integrations/gridview/ninjaVan.png';
import cityLinkGrid from 'assets/images/integrations/gridview/cityLink.png';
import easyEcomGrid from 'assets/images/integrations/listview/easyEcom.png';
import boxme from 'assets/images/integrations/listview/boxme.png';
import nykaa from 'assets/images/integrations/listview/nykaa.png';
import nykaaGrid from 'assets/images/integrations/gridview/nykaa.png';
import shopeeGlobalGrid from 'assets/images/integrations/gridview/shopeeGlobal.png';
import ajioGrid from 'assets/images/integrations/gridview/ajio.png';
import tiktokAdsGrid from 'assets/images/integrations/gridview/tiktokAds.png';
import lazadaGlobalGrid from 'assets/images/integrations/listview/Lazada-global.png';
import zaloraGlobalGrid from 'assets/images/integrations/listview/zalora-global.png';
import amazonVendorCentralGrid from 'assets/images/integrations/listview/amazonVendorCentral.png';
import unicommerceGrid from 'assets/images/integrations/gridview/unicommerce.png';
import myntraSjitGrid from 'assets/images/integrations/gridview/myntraSjit.png';
import zeptoGrid from 'assets/images/integrations/gridview/zepto.png';
import instamartGrid from 'assets/images/integrations/gridview/instamart.png';
import blinkitGrid from 'assets/images/integrations/gridview/blinkit.png';
import meeshoGrid from 'assets/images/integrations/gridview/meesho.png';
import tataCliqGrid from 'assets/images/integrations/gridview/tatacliq.png';
import spxGrid from 'assets/images/integrations/listview/spx.png';

import { Select } from 'antd';
import {
  isUndefined as _isUndefined,
  get as _get,
  forEach as _forEach,
  isEmpty as _isEmpty,
  map as _map,
  isNull as _isNull
} from 'lodash-es';
import moment from 'moment';
import { getNickNameValue } from 'utilities/utilities_exports';
import Icon from 'components/Icon';
import googleAdsLogo from 'assets/images/integrations/avator_google_ads_logo.png';
import amazonAdsLogo from 'assets/images/integrations/avator_Amazon_logo.png';
import tiktokAdsLogo from 'assets/images/integrations/avator_tiktok_ads_logo.png';
import { apiServices } from 'redux/utils/api_services';
import { patchUpdateFromApiAction } from 'components/Atoms/GraasApiUtility/GraasApiUtility.action';

const { Option } = Select;

// ** category mapper
export const mapper = {
  all: {
    title: 'All',
    local_key: 'GRAAS_ALL_GRAAS'
  },
  marketplaces: {
    title: 'Marketplaces',
    local_key: 'GRAAS_MARKETPLACES_GRAAS'
  },
  globalMarketplaces: {
    title: 'Global Marketplaces',
    local_key: 'GRAAS_GLOBAL_MARKETPLACES_GRAAS'
  },
  emailMarketing: {
    title: 'Email Marketing',
    local_key: 'GRAAS_EMAIL_MARKETING_GRAAS'
  },
  analytics: {
    title: 'Analytics',
    local_key: 'GRAAS_ANALYTICS_GRAAS'
  },
  d2c: {
    title: 'D2C Platform',
    local_key: 'GRAAS_D2C_GRAAS'
  },
  b2b: {
    title: 'B2B Platform',
    local_key: 'GRAAS_B2B_PLATFORM_GRAAS'
  },
  seo: {
    title: 'SEO',
    local_key: 'GRAAS_SEO_GRAAS'
  },
  logistics: {
    title: 'Logistics',
    local_key: 'GRAAS_LOGISTICS_GRAAS'
  },
  warehouse: {
    title: 'Warehouse',
    local_key: 'GRAAS_WAREHOUSE_GRAAS'
  },
  erp: {
    title: 'ERP/POS',
    local_key: 'GRAAS_ERP_POS_GRAAS'
  },
  Offline: {
    title: 'Offline',
    local_key: 'GRAAS_OFFLINE_GRAAS'
  },
  Websites: {
    title: 'Websites',
    local_key: 'GRAAS_WEBSITES_GRAAS'
  },
  marketing: {
    title: 'Marketing Platform',
    local_key: 'GRAAS_MARKTING_PLATFORM_GRAAS'
  },
  others: {
    title: 'Others',
    local_key: 'GRAAS_OTHERS_GRAAS'
  },
  chatInquiry: {
    title: 'Chat Inquiry',
    local_key: 'GRAAS_CHAT_INQUIRY_GRAAS'
  },
  qcommerce: {
    title: 'qcommerce',
    local_key: 'GRAAS_QCOMMERCE_GRAAS'
  }
};
export const showStatus = (store, icon) => {
  if (isReAuthNeeded(store)) {
    //--- this return className
    if (icon) {
      return 'warning';
    }
    return 'Reauthentication required';
  } else {
    if (store?.status === 'X') {
      return 'Inactive';
    } else {
      return 'Active';
    }
  }
};
export const isReAuthNeeded = channel => {
  const refreshTokenExpiryDate = _get(channel, 'postHelper.refreshTokenExipryDate');
  const status = _get(channel, 'status', 'A');
  const thirtyDaysInSeconds = 30 * 24 * 60 * 60;
  const currentTimeInSeconds = Math.floor(Date.now() / 1000) + thirtyDaysInSeconds;
  if ((status === 'A' || status === 'X') && currentTimeInSeconds > refreshTokenExpiryDate) {
    return true;
  }
  return false;
};
export const listViewIdToImageMap = {
  amazon: amazon,
  shopify: shopify,
  shopee: shopee,
  mailchimp: mailchimp,
  googleAnalytics: googleAnalytics,
  blibli: blibli,
  bukalapak: bukalapak,
  delhivery: delhivery,
  eBay: eBay,
  elevenStreet: elevenStreet,
  etsy: etsy,
  facebookAds: facebookAds,
  amazonAds: amazonAds,
  flipkart: flipkart,
  googleAds: googleAds,
  googleSearchConsole: googleSearchConsole,
  jd: jd,
  lazada: lazada,
  lighthouse: lighthouse,
  magento: magento,
  myntra: myntra,
  prestaShop: prestaShop,
  qoo10: qoo10,
  salesforce: salesforce,
  semrush: semrush,
  shiprocket: shiprocket,
  singPost: singPost,
  tiki: tiki,
  tiktok: tiktok,
  tokopedia: tokopedia,
  tokopediaShop: tokopediaShop,
  wooCommerce: wooCommerce,
  zalora: zalora,
  jtExpress: jtExpress,
  MyStock: MyStock,
  netSuite: netSuite,
  odoo: odoo,
  offline: offline,
  sap: sap,
  satsaco: satsaco,
  vend: vend,
  SiAWMS: SiAWMS,
  ych: ych,
  aramex: aramex,
  aramexShipping: aramexShipping,
  customWMS: customWMS,
  customERP: customERP,
  eccang: eccang,
  infor: infor,
  janio: janio,
  ninjaVan: ninjaVan,
  cityLink: cityLink,
  easyEcom: easyEcom,
  flowgistik: flow,
  boxme: boxme,
  nykaa: nykaa,
  shopeeGlobal: shopeeGlobal,
  ajio: ajio,
  spx: spx,
  tiktokAds,
  lazadaGlobal,
  zaloraGlobal,
  amazonVendorCentral,
  shopeeChatInquiry: shopee_chat,
  lazadaChatInquiry: lazada_chat,
  tokopediaChatInquiry: tokopedia_chat,
  unicommerce,
  myntraSjit,
  zepto,
  instamart,
  blinkit,
  meesho,
  tataCliq
};

export const gridViewIdToImageMap = {
  amazon: amazonGrid,
  shopify: shopifyGrid,
  shopee: shopeeGrid,
  mailchimp: mailchimpGrid,
  googleAnalytics: googleAnalyticsGrid,
  blibli: blibliGrid,
  bukalapak: bukalapakGrid,
  delhivery: delhiveryGrid,
  eBay: eBayGrid,
  elevenStreet: elevenStreetGrid,
  etsy: etsyGrid,
  facebookAds: facebookAdsGrid,
  amazonAds: amazonAdsGrid,
  flipkart: flipkartGrid,
  googleAds: googleAdsGrid,
  googleSearchConsole: googleSearchConsoleGrid,
  jd: jdGrid,
  lazada: lazadaGrid,
  lighthouse: lighthouseGrid,
  magento: magentoGrid,
  myntra: myntraGrid,
  prestaShop: prestaShopGrid,
  qoo10: qoo10Grid,
  salesforce: salesforceGrid,
  semrush: semrushGrid,
  shiprocket: shiprocketGrid,
  singPost: singPostGrid,
  tiki: tikiGrid,
  tiktok: tiktokGrid,
  tokopedia: tokopediaGrid,
  tokopediaShop: tokopediaShopGrid,
  wooCommerce: wooCommerceGrid,
  zalora: zaloraGrid,
  jtExpress: jtExpressGrid,
  MyStock: MyStockGrid,
  netSuite: netSuiteGrid,
  odoo: odooGrid,
  offline: offlineGrid,
  sap: sapGrid,
  satsaco: satsacoGrid,
  vend: vendGrid,
  SiAWMS: SiAWMSGrid,
  ych: ychGrid,
  aramex: aramexGrid,
  aramexShipping: aramexShippingGrid,
  customWMS: customWMSGrid,
  customERP: customERPGrid,
  eccang: eccangGrid,
  infor: inforGrid,
  janio: janioGrid,
  ninjaVan: ninjaVanGrid,
  cityLink: cityLinkGrid,
  easyEcom: easyEcomGrid,
  boxme,
  flowgistik: flow,
  nykaa: nykaaGrid,
  shopeeGlobal: shopeeGlobalGrid,
  ajio: ajioGrid,
  tiktokAds: tiktokAdsGrid,
  lazadaGlobal: lazadaGlobalGrid,
  zaloraGlobal: zaloraGlobalGrid,
  amazonVendorCentral: amazonVendorCentralGrid,
  unicommerce: unicommerceGrid,
  shopeeChatInquiry: shopee_chat,
  lazadaChatInquiry: lazada_chat,
  tokopediaChatInquiry: tokopedia_chat,
  myntraSjit: myntraSjitGrid,
  zepto: zeptoGrid,
  instamart: instamartGrid,
  blinkit: blinkitGrid,
  meesho: meeshoGrid,
  tataCliq: tataCliqGrid,
  spx: spxGrid
};

export const logoToImageMap = {
  googleAds: googleAdsLogo,
  facebookAds: facebookAds,
  amazonAds: amazonAdsLogo,
  tiktokAds: tiktokAdsLogo
};

export const getAmazonShippingCarrierInitial = [
  {
    id: 'none',
    value: 'none'
  },
  {
    id: 'ninjaVan',
    value: 'Ninja Van'
  },
  {
    id: 'delhivery',
    value: 'Delhivery'
  },
  {
    id: 'janio',
    value: 'Janio'
  }
];

// --- channel priority by country
export const priorityChannels = {
  SG: ['amazon', 'lazada', 'shopee', 'shopify'],
  ID: ['tokopedia', 'magento'],
  IN: ['flipkart', 'amazon']
};

export const amazonSellerSupportedCountries = [
  'SG',
  'IN',
  'US',
  'GB',
  'CA',
  'MX',
  'BR',
  'ES',
  'FR',
  'BE',
  'NL',
  'DE',
  'IT',
  'SE',
  'PL',
  'EG',
  'TR',
  'SA',
  'AE',
  'AU',
  'JP'
];

export const amazonVendorCentralSupportedCountries = [
  'SG',
  'IN',
  'US',
  'GB',
  'CA',
  'MX',
  'BR',
  'ES',
  'FR',
  'BE',
  'NL',
  'DE',
  'IT',
  'SE',
  'PL',
  'EG',
  'TR',
  'SA',
  'AE',
  'AU',
  'JP'
];

export const amazonVendorCentralProgram = ['Amazon Retail', 'Amazon Fresh', 'Amazon Business'];
export const amazonVendorCentralDistributorView = ['manufacturing', 'sourcing'];

export const getInvoiceTemplateArray = [
  {
    id: '1',
    value: 'Template 1'
  },
  {
    id: '2',
    value: 'eBay Template'
  },
  {
    id: '3',
    value: 'Template 3'
  },
  {
    id: '4',
    value: 'Lazada Template'
  },
  {
    id: '5',
    value: '11street Template'
  },
  {
    id: '6',
    value: 'Shipping Invoice Template'
  },
  {
    id: '7',
    value: 'Delhivery Invoice Template'
  },
  {
    id: '8',
    value: 'Template 8'
  },
  {
    id: '9',
    value: 'Template 9'
  },
  {
    id: '10',
    value: 'Template 10'
  },
  {
    id: '11',
    value: 'Bukalapak Template'
  }
];

export const getInvoiceNickNameValue = (nickNameId, initialInvoiceTemplate) => {
  if (_isEmpty(nickNameId) || nickNameId === 'null') {
    return 'NA';
  }
  const filteredArray = initialInvoiceTemplate.filter(function (invoice) {
    return invoice.id === nickNameId;
  });
  var isAvailableInOtherTemplate = getInvoiceTemplateArray.filter(function (object) {
    return object.id === nickNameId ?? '';
  });
  if (_isEmpty(isAvailableInOtherTemplate)) {
    return nickNameId?.split('-')[0] + '-' + filteredArray[0]?.value;
  } else {
    return isAvailableInOtherTemplate?.[0]?.value || '';
  }
};

export const getListOfNickName = (listArray, response, type) => {
  if (listArray === undefined) {
    return 'NA';
  }
  let fullchannel = '';
  for (let i = 0; i < listArray.length; i++) {
    if (fullchannel !== '') {
      fullchannel += ', ';
    }
    fullchannel += getLookUpNickName(response, type, listArray[i]);
  }
  if (fullchannel === '') {
    return 'NA';
  }
  return fullchannel;
};

export const getLookUpNickName = (response, type, nickNameID) => {
  if (_isEmpty(nickNameID) || nickNameID === 'null') {
    return 'NA';
  }
  const data = response?.[type] || [];
  const matchedNickNameObject = data.find(nickNameObject => nickNameObject?.id === nickNameID);
  if (matchedNickNameObject) {
    const prefix = nickNameID?.split('-')[0];
    const nickName = matchedNickNameObject.value;
    return `${prefix}-${nickName}`;
  }
  return nickNameID;
};

export const getShippingServiceProvidersOptionList = channelData => {
  let selectedShippingServiceProviders = [];
  if (!_isUndefined(channelData?.shippingServiceProvider)) {
    if (!!channelData?.shippingServiceProvider?.length) {
      _forEach(channelData?.shippingServiceProvider, shippingServiceProvider => {
        let optionValue = shippingServiceProvider?.id;
        if (_isUndefined(optionValue)) {
          optionValue = shippingServiceProvider?.code;
        }
        selectedShippingServiceProviders?.push({
          label: shippingServiceProvider?.name,
          value: optionValue,
          selected: !_isUndefined(shippingServiceProvider?.preferred) && shippingServiceProvider?.preferred
        });
      });
    }
  }
  return selectedShippingServiceProviders;
};

export const storePickupAddressOptionList = channelData => {
  const storePickupAddressList = [];
  const channelName = channelData?.nickName?.id?.split('-')[0];
  const pickUpAddressDetails = channelData?.storePickUpDetails?.pickUpAddressDetails || [];
  _forEach(pickUpAddressDetails, pickUpAddress => {
    let text, value;
    if (['tiki'].includes(channelName)) {
      text = pickUpAddress?.name;
      value = pickUpAddress?.id;
    } else if (['tiktok'].includes(channelName)) {
      text = pickUpAddress?.warehouse_name;
      value = pickUpAddress?.warehouse_id;
    } else {
      text = `${pickUpAddress?.address}-${pickUpAddress?.country} ${pickUpAddress?.zipcode}`;
      value = pickUpAddress?.addressId;
    }
    storePickupAddressList?.push({
      label: text,
      value: value,
      selected: pickUpAddress?.preferred || false
    });
  });
  return storePickupAddressList;
};

export const displaySelectedStores = (stores, nickNames, isConnectedStore) => {
  if (isConnectedStore && stores.length === 0) {
    return (
      <span>
        None <Icon name='warning' isBordered color='#FDB022' />
      </span>
    );
  }

  if (stores.length === 0) {
    return 'NA';
  }

  var displayValue = '';
  for (var i in stores) {
    displayValue +=
      (displayValue !== '' ? ', ' : '') + stores[i]?.split('-')[0] + ' - ' + getNickNameValue(nickNames, stores[i]);
  }
  return displayValue;
};

export const loadInvoiceDropDown = data => {
  if (data === undefined) {
    return <></>;
  }

  return data.map(value => (
    <Option key={value?.id} value={value?.id}>
      {value?.value}
    </Option>
  ));
};

export const loadOrderStatusDropDown = data => {
  if (data === undefined) {
    return <></>;
  }
  return data.map((value, index) => (
    <Option key={index} value={value}>
      {value}
    </Option>
  ));
};

export const loadDropDown = data => {
  if (data === undefined) {
    return <></>;
  }
  return data.map((value, index) => (
    <Option key={index} value={value?.id}>
      {value?.id.split('-')[0] + '-' + value?.value}
    </Option>
  ));
};

export const loadConnectedListDropDown = data => {
  if (data === undefined) {
    return <></>;
  }
  return data.map(value => (
    <Option
      key={value?.id}
      value={`${value?.id}--${value?.name}--${value?.currencyCode}--${value?.type}--${value?.timeZone}--${value?.clientCustomerID}`}
      label={value?.name}
    >
      {value?.name}
    </Option>
  ));
};

export const shippingServiceProviderOptionsList = channel => {
  const shippingServiceProviderOptionList = [];
  const shippingServiceProvider = channel?.shippingServiceProvider;
  if (shippingServiceProvider && shippingServiceProvider.length > 0) {
    _forEach(shippingServiceProvider, deliveryOption => {
      const { delivery_option_id: value, delivery_option_name: text } = deliveryOption;
      shippingServiceProviderOptionList?.push({ label: text, value });
    });
  }
  return shippingServiceProviderOptionList;
};

const redirectSupportChannel = ['facebookAds', 'googleAds', 'googleAnalytics', 'googleSearchConsole'];

export const getStoreStatus = (channelObj, channel) => {
  let status = 'Active';
  if (channelObj?.status === 'X' || channelObj?.accountStatus === 'X') {
    status = 'Inactive';
  } else if (channelObj?.isReauthRequired) {
    status = 'REAUTHENTICATE_REQUIRED';
  } else if (
    channelObj.status === 'I' ||
    (redirectSupportChannel.includes(channel) &&
      (!channelObj?.connectedAccountList || channelObj.connectedAccountList.length === 0))
  ) {
    status = 'Incomplete';
  }
  return status;
};

export const calculateDayDiffrence = (startDate, endDate) => {
  const startMoment = moment(startDate);
  const endMoment = moment(endDate);
  const diffDays = endMoment.diff(startMoment, 'days');
  return diffDays;
};

export const shippingDeliveryOptionList = channel => {
  const shippingDeliveryOptionList = [];
  const shippingDeliveryOptions = channel?.shippingDeliveryOptions;
  if (shippingDeliveryOptions && shippingDeliveryOptions.length > 0) {
    for (const deliveryOption of shippingDeliveryOptions) {
      const { delivery_option_id: value, delivery_option_name: text } = deliveryOption;
      shippingDeliveryOptionList?.push({ label: text, value });
    }
  }
  return shippingDeliveryOptionList;
};

//-- actual shipping label template value
export const getActualShippingLabelTemplateValue = (id, apiData, shippingLabelTemplateOptions) => {
  const foundObject = shippingLabelTemplateOptions?.find(item => item?.id === id);
  if (foundObject) {
    return foundObject?.value || id;
  }
  const foundFormObject = apiData?.shippingLabelTemplate?.find(element => element?.id === id);
  if (foundFormObject) {
    return `${foundFormObject?.id?.split('-')?.[0]}-${foundFormObject?.value}`;
  }
  return id;
};

export const getConnectedTimeInfo = store => {
  if (store?.timeLinked) {
    return moment.unix(store.timeLinked).isSame(moment().subtract(1, 'day'), 'day')
      ? 'Yesterday'
      : moment.unix(store.timeLinked).fromNow();
  } else {
    return 'NA';
  }
};

export const getExpiryTimeInfo = (expiryTime, t) => {
  const currentTime = new Date().getTime();
  const dayDiff = calculateDayDiffrence(currentTime, expiryTime);
  if (dayDiff <= 0) {
    if (currentTime > expiryTime) {
      return t('GRAAS_EXPIRED_GRAAS');
    }
    return t('GRAAS_EXPIRES_WITHIN_24_HOURS_GRAAS');
  }
  return dayDiff === 1
    ? `${t('GRAAS_EXPIRES_IN_ONE_DAY_WARNING_GRAAS', { 0: dayDiff })}`
    : `${t('GRAAS_EXPIRES_IN_WARNING_GRAAS', { 0: dayDiff })}`;
};

export const primaryCurrencyArray = [
  {
    currencyCode: 'USD',
    currencyName: 'US Dollar'
  },
  {
    currencyCode: 'CAD',
    currencyName: 'Canadian Dollar'
  },
  {
    currencyCode: 'GBP',
    currencyName: 'British Pound'
  },
  {
    currencyCode: 'AUD',
    currencyName: 'Australian Dollar'
  },
  {
    currencyCode: 'EUR',
    currencyName: 'Euro'
  },
  {
    currencyCode: 'HKD',
    currencyName: 'Hong Kong Dollar'
  },
  {
    currencyCode: 'CHF',
    currencyName: 'Swiss Franc'
  },
  {
    currencyCode: 'INR',
    currencyName: 'Indian Rupee'
  },
  {
    currencyCode: 'IDR',
    currencyName: 'Indonesian Rupiah'
  },
  {
    currencyCode: 'MYR',
    currencyName: 'Malaysian Ringgit'
  },
  {
    currencyCode: 'PHP',
    currencyName: 'Philippine Peso'
  },
  {
    currencyCode: 'PLN',
    currencyName: 'Polish Zloty'
  },
  {
    currencyCode: 'SGD',
    currencyName: 'Singapore Dollar'
  },
  {
    currencyCode: 'JPY',
    currencyName: 'Japanese Yen'
  }
];

export const configJsonSites = [
  'sellInAll',
  'eBay',
  'shopify',
  'amazon',
  'flipkart',
  'shopclues',
  'lazada',
  'etsy',
  'magento',
  'snapdeal',
  'qoo10',
  'shopee',
  'elevenStreet',
  'wish',
  'zalora',
  'jd',
  'bukalapak',
  '99SME',
  'blibli',
  'wooCommerce',
  'tokopedia',
  'tiki',
  'prestaShop',
  'salesforce',
  'capillary',
  'tiktok'
];

export const skippedChannelFromLits = ['sellInAll', 'MyStock'];

//--- function to get satsaco checkbox array & enabled channels
export const satsacoChannelArray = (accountDetails, data, isEnabled) => {
  const requiredChannelArray = [];
  const requiredEnabledChannels = [];
  _forEach(configJsonSites, item => {
    if (accountDetails[item]) {
      _forEach(accountDetails[item], element => {
        if (element?.status !== 'X' && !_isUndefined(element?.wms)) {
          requiredChannelArray?.push(element?.nickName);
        }
        if (element?.wms?.includes(data?.nickName?.id)) {
          requiredEnabledChannels?.push(element?.nickName?.id);
        }
      });
    }
  });
  if (isEnabled) {
    return requiredEnabledChannels;
  }
  return requiredChannelArray;
};

//--- shipping carrier option in custom flow
export const customFlowShippingCarrierOptions = [
  { value: 'createOrder', label: 'Create Order' },
  { value: 'updateOrder', label: 'Update Order' },
  { value: 'cancelOrder', label: 'Cancel Order' },
  { value: 'returnOrder', label: 'Return Order' },
  { value: 'inventorySync', label: 'Inventory Sync' },
  { value: 'quantityChange', label: 'Quantity Change' },
  { value: 'createAsn', label: 'Create ASN' },
  { value: 'processNotification', label: 'Process Notification' },
  { value: 'orderPolling', label: 'Order Polling' },
  { value: 'inventoryPolling', label: 'Inventory Polling' },
  { value: 'orderNotification', label: 'Order Notification' }
];

export const isValidURL = url => {
  // Regular expression for URL validation
  const urlPattern = new RegExp(/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/i);
  return urlPattern.test(url);
};

// --- ignore list
export const pendingIntegrations = [];

// --- Disabled list
export const disabledIntegrations = ['jd', 'eccang', 'aramexShipping'];

// Allowed connect menus
export const allowedConnectMenus = ['store-group', 'mapping', 'journal'];

// --- Removed Integrations
export const removedIntegrations = ['shiprocket', 'mailchimp', 'lighthouse', 'semrush', 'googleSearchConsole'];

export const getConnectedStores = apiResponse => {
  let notConnectedNickNames = '';
  _map(apiResponse?.list, store => {
    if (_isEmpty(store?.linkedStores) || store?.linkedStores?.length === 0) {
      if (!_isEmpty(notConnectedNickNames)) {
        notConnectedNickNames += ', ';
      }
      notConnectedNickNames += store?.nickName?.id.split('-')?.[0] + '-' + store?.nickName?.value;
    }
  });
  return notConnectedNickNames;
};

//Returns sentence cased words => eg. facebookAds-1 => Facebook Ads 1
export const splitAndCapitalizeWord = inputWord => {
  let words = inputWord.split(/(?=[A-Z-])/);
  let capitalizedWords = words.map(word => word.replace('-', ' ').charAt(0).toUpperCase() + word.slice(1));
  let result = capitalizedWords.join(' ');
  return result ?? null;
};

export const populateMarketingChannelDetails = data => {
  if (data?.adAccounts) {
    return data.adAccounts.map((channel, index) => {
      return (
        <div key={index}>
          <Space>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <img src={logoToImageMap[channel.split('-')[0]]} height='30' alt={channel.split('-')[0]} />
              <span className='c-heading sm color-dark' style={{ margin: 0 }}>
                {splitAndCapitalizeWord(channel)}
              </span>
            </div>
            <br />
          </Space>
        </div>
      );
    });
  }
};

export const chromeExtensionEnableChannels = ['lazada', 'shopee', 'tokopedia', 'amazon', 'flipkart'];

export const getConnectedChannel = (list, channel) => {
  // const finalStoreList = _filter(list, store => !skippedChannelFromLits.includes(store?.split('-')?.[0]));
  // if (finalStoreList?.length === 1) {
  //   return 'first_channel';
  // }
  return channel;
};

export const countryChannelMapping = {
  SG: [
    'shopee',
    'lazada',
    'shopify',
    'salesforce',
    'magento',
    'zalora',
    'wooCommerce',
    'tiktok',
    'amazon',
    'shopeeGlobal',
    'etsy',
    'eBay',
    'zaloraGlobal',
    'qoo10',
    'prestaShop',
    'googleAds',
    'facebookAds',
    'tokopedia',
    'amazonAds',
    'tiktokAds',
    'amazonVendorCentral',
    'googleAnalytics',
    'blibli',
    'tiki',
    'elevenStreet',
    'bukalapak',
    'ajio',
    'flipkart',
    'myntra',
    'nykaa',
    'easyEcom',
    'unicommerce'
  ],

  PH: [
    'shopee',
    'lazada',
    'tiktok',
    'shopify',
    'zalora',
    'salesforce',
    'prestaShop',
    'shopeeGlobal',
    'wooCommerce',
    'etsy',
    'eBay',
    'googleAds',
    'facebookAds',
    'tiktokAds',
    'magento',
    'amazon',
    'flipkart',
    'myntra',
    'nykaa',
    'tokopedia',
    'blibli',
    'tiki',
    'elevenStreet',
    'bukalapak',
    'qoo10',
    'ajio',
    'amazonVendorCentral',
    'zaloraGlobal',
    'amazonAds',
    'googleAnalytics',
    'easyEcom',
    'unicommerce'
  ],
  ID: [
    'shopee',
    'lazada',
    'tiktok',
    'tokopedia',
    'shopify',
    'blibli',
    'zalora',
    'wooCommerce',
    'salesforce',
    'bukalapak',
    'magento',
    'shopeeGlobal',
    'prestaShop',
    'googleAds',
    'facebookAds',
    'tiktokAds',
    'amazon',
    'flipkart',
    'myntra',
    'nykaa',
    'tiki',
    'elevenStreet',
    'etsy',
    'qoo10',
    'eBay',
    'ajio',
    'amazonVendorCentral',
    'zaloraGlobal',
    'amazonAds',
    'googleAnalytics',
    'easyEcom',
    'unicommerce'
  ],
  MY: [
    'shopee',
    'lazada',
    'shopify',
    'tiktok',
    'zalora',
    'shopeeGlobal',
    'magento',
    'salesforce',
    'wooCommerce',
    'eBay',
    'zaloraGlobal',
    'googleAds',
    'facebookAds',
    'tiktokAds',
    'prestaShop',
    'amazon',
    'flipkart',
    'myntra',
    'nykaa',
    'tokopedia',
    'blibli',
    'tiki',
    'elevenStreet',
    'etsy',
    'bukalapak',
    'qoo10',
    'ajio',
    'amazonVendorCentral',
    'amazonAds',
    'googleAnalytics',
    'easyEcom',
    'unicommerce'
  ],
  VN: [
    'shopee',
    'lazada',
    'shopify',
    'tiktok',
    'tiki',
    'magento',
    'googleAds',
    'facebookAds',
    'amazonAds',
    'tiktokAds',
    'wooCommerce',
    'prestaShop',
    'salesforce',
    'amazon',
    'flipkart',
    'myntra',
    'nykaa',
    'tokopedia',
    'blibli',
    'zalora',
    'elevenStreet',
    'etsy',
    'bukalapak',
    'qoo10',
    'eBay',
    'ajio',
    'amazonVendorCentral',
    'shopeeGlobal',
    'zaloraGlobal',
    'googleAnalytics',
    'easyEcom',
    'unicommerce'
  ],
  IN: [
    'shopify',
    'amazon',
    'magento',
    'flipkart',
    'myntra',
    'wooCommerce',
    'nykaa',
    'ajio',
    'amazonVendorCentral',
    'zepto',
    'instamart',
    'blinkit',
    'googleAds',
    'facebookAds',
    'amazonAds',
    'eBay',
    'etsy',
    'salesforce',
    'googleAnalytics',
    'easyEcom',
    'unicommerce',
    'prestaShop',
    'lazada',
    'tokopedia',
    'tiktok',
    'blibli',
    'zalora',
    'tiki',
    'elevenStreet',
    'bukalapak',
    'qoo10',
    'shopeeGlobal',
    'zaloraGlobal',
    'tiktokAds',
    'shopee'
  ],
  TH: [
    'shopee',
    'tiktok',
    'lazada',
    'salesforce',
    'shopify',
    'shopeeGlobal',
    'magento',
    'wooCommerce',
    'googleAds',
    'facebookAds',
    'tiktokAds',
    'prestaShop',
    'amazon',
    'flipkart',
    'myntra',
    'nykaa',
    'tokopedia',
    'blibli',
    'zalora',
    'tiki',
    'elevenStreet',
    'etsy',
    'bukalapak',
    'qoo10',
    'eBay',
    'ajio',
    'amazonVendorCentral',
    'zaloraGlobal',
    'amazonAds',
    'googleAnalytics',
    'easyEcom',
    'unicommerce'
  ],
  US: [
    'amazon',
    'shopify',
    'magento',
    'wooCommerce',
    'tiktok',
    'eBay',
    'googleAds',
    'facebookAds',
    'tiktokAds',
    'amazonAds',
    'salesforce',
    'amazonVendorCentral',
    'etsy',
    'googleAnalytics',
    'prestaShop',
    'qoo10',
    'flipkart',
    'myntra',
    'nykaa',
    'lazada',
    'shopee',
    'tokopedia',
    'blibli',
    'zalora',
    'tiki',
    'elevenStreet',
    'bukalapak',
    'ajio',
    'shopeeGlobal',
    'zaloraGlobal',
    'easyEcom',
    'unicommerce'
  ],
  default: ['amazon', 'shopify', 'facebookAds', 'googleAds']
};

export const isTrackerConnected = lastTrackerScannedTime => {
  var sevenDaysBeforeTime = Math.floor(Date.now() / 1000) - 7 * 24 * 60 * 60;
  if (lastTrackerScannedTime < sevenDaysBeforeTime) {
    return false;
  }
  return true;
};

export const getStatusAndIcon = store => {
  const status = store?.status ?? 'A';

  if (status === 'X') return { icon: 'warning', status: 'INACTIVE' };
  if (status === 'I' || (store?.availableAccountList?.length >= 0 && !store?.connectedAccountList?.length > 0))
    return { icon: 'inComplete', status: 'INCOMPLETE' };
  if (store.isNotConnected) return { icon: 'warning', status: 'NOT_CONNECTED' };
  if (store.isReauthRequired || status === 'R') return { icon: 'warning', status: 'REAUTHENTICATE_REQUIRED' };
  return { icon: 'active', status: 'ACTIVE' };
};

export const D2CChannels = ['shopify', 'magento', 'wooCommerce', 'prestaShop', 'salesforce'];

export const mapChannelStoryLane = {
  lazada: 'https://graas.storylane.io/share/bh6bzcfz66sl',
  shopee: 'https://graas.storylane.io/share/0gfesinme3z2',
  tokopedia: 'https://graas.storylane.io/share/cp7yppefjq2p',
  tiktok: 'https://graas.storylane.io/share/hki7tmyk2zsm',
  flipkart: 'https://graas.storylane.io/share/nxafz7blgfsb',
  amazon: 'https://graas.storylane.io/share/gbbpndgqijrq',
  blibli: 'https://graas.storylane.io/share/9umj23h8sqo3',
  zalora: 'https://graas.storylane.io/share/op1rxyvkvnt0',
  tiki: 'storylink_tiki',
  elevenstreet: 'storylink_elevenStreet',
  etsy: 'https://graas.storylane.io/share/naloplxzooc7',
  bukalapak: 'storylink_bukalapak',
  qoo10: 'https://graas.storylane.io/share/izu6qqgyyzb4',
  ebay: 'storylink_ebay',
  nykaa: 'storylink_nykaa',
  myntra: 'storylink_myntra',
  ajio: 'storylink_ajio',
  shopeeglobal: 'storylink_shopeeGlobal',
  shopify: 'https://graas.storylane.io/share/orgijtmhl8mb',
  magento: 'https://graas.storylane.io/share/lzzukhj8nxys',
  woocommerce: 'https://graas.storylane.io/share/r5adfvsrkvb9',
  prestashop: 'https://graas.storylane.io/share/3a9qdiros7xg',
  salesforce: 'https://graas.storylane.io/share/76hzwaz3gnsq',
  googleads: 'https://graas.storylane.io/share/8trkair2fcep',
  facebookads: 'https://graas.storylane.io/share/nrokl2wzgrb3',
  amazonads: 'storylink_amazonAds',
  googlesearchconsole: 'storylink_googleSearchConsole',
  semrush: 'https://graas.storylane.io/share/h4gr4cg4et7n',
  googleanalytics: 'storylink_googleAnalytics',
  shiprocket: 'storylink_shiprocket',
  singpost: 'storylink_singPost',
  jtexpress: 'https://graas.storylane.io/share/snifqlodpe0d',
  janio: 'storylink_janio',
  aramexshipping: 'storylink_aramexShipping',
  ninjavan: 'storylink_ninjaVan',
  citylink: 'storylink_cityLink',
  mailchimp: 'storylink_mailchimp',
  lighthouse: 'storylink_lighthouse',
  mystock: 'storylink_myStock',
  infor: 'storylink_infor',
  ych: 'storylink_ych',
  aramex: 'storylink_aramex',
  satsaco: 'storylink_satsaco',
  siawms: 'storylink_siAWMS',
  customwms: 'storylink_customWMS',
  boxme: 'storylink_boxme',
  flowgistik: 'storylink_flowgistik',
  netsuite: 'https://graas.storylane.io/share/uqtsli8noypg',
  sap: 'https://graas.storylane.io/share/l6hlujd1pazm',
  vend: 'storylink_vend',
  eccang: 'storylink_eccang',
  odoo: 'storylink_odoo',
  offline: 'storylink_offline',
  easyecom: 'storylink_easyEcom',
  zaloraglobal: 'https://graas.storylane.io/share/lntjfklbj7uo',
  flipkart_team_id: 'https://graas.storylane.io/share/isu4xiuu1rdd',
  unicommerce: 'https://graas.storylane.io/share/wlgpisadolcz',
  myntra_team_id: 'https://graas.storylane.io/share/4ycckux5jckm'
};

export const updateUserData = async (nickNameId, userDetails, integration = 'channel') => {
  if (userDetails?.type === 'user' && !_isEmpty(nickNameId) && !_isNull(nickNameId)) {
    const apiUrl = `${apiServices['account']}/services/users/permission`;
    const response = await patchUpdateFromApiAction(apiUrl, {
      userId: userDetails?.userId,
      [integration === 'wms' ? 'wmsPermissions' : 'channelPermissions']: [nickNameId],
      operator: 'push'
    });
    if (response?.response !== 'success' || response?.hasError) {
      console.log("Failed to update permission in user data and it's response : ", response);
    }
  }
};

export const getSellerCentreURL = {
  LAZADA: {
    SGD: 'https://sellercenter.lazada.sg/',
    MYR: 'https://sellercenter.lazada.com.my/',
    IDR: 'https://sellercenter.lazada.co.id/',
    PHP: 'https://sellercenter.lazada.com.ph/',
    THB: 'https://sellercenter.lazada.co.th/',
    VND: 'https://sellercenter.lazada.vn/',
    GLOBAL: 'https://gsp.lazada.com/page/login'
  },
  SHOPEE: {
    SGD: 'https://shopee.sg/seller/login',
    MYR: 'https://shopee.com.my/seller/login',
    IDR: 'https://shopee.co.id/seller/login',
    PHP: 'https://shopee.ph/seller/login',
    THB: 'https://shopee.co.th/',
    VND: 'https://shopee.vn/seller/login'
  },
  FLIPKART: {
    INR: 'https://seller.flipkart.com/'
  },
  TOKOPEDIA: {
    IDR: 'https://www.tokopedia.com/login'
  },
  AMAZON: {
    SGD: 'https://sellercentral.amazon.sg/',
    INR: 'https://sellercentral.amazon.in/'
  }
};

export const isShopeeReAuthNeeded = channel => {
  const status = _get(channel, 'status', 'A');
  if (status === 'A' || status === 'X') {
    if (channel?.chatRefreshTokenUpdatedTime !== undefined) {
      const chatRefreshTokenUpdatedTime = channel.chatRefreshTokenUpdatedTime;
      let dayDiff = calculateDayDiffrence(chatRefreshTokenUpdatedTime * 1000, new Date().getTime());
      if (dayDiff > 1) {
        return true;
      }
      if (channel?.expiryTime !== undefined) {
        const expiryTime = channel.expiryTime;
        dayDiff = calculateDayDiffrence(new Date().getTime(), expiryTime * 1000);
        if (dayDiff <= 6) {
          return true;
        }
      }
    } else {
      return true;
    }
  }
  return false;
};

//Check is reAuth needed
export const isLazadaReAuthNeeded = channel => {
  const refreshTokenExpiryDate = _get(channel, 'postHelper.chatRefreshTokenExipryDate');
  const status = _get(channel, 'status', 'A');
  const sevenDaysInSeconds = 7 * 24 * 60 * 60; // changed to 7 days . due to lazada new api changes.
  const currentTimeInSeconds = Math.floor(Date.now() / 1000) + sevenDaysInSeconds;
  if ((status === 'A' || status === 'X') && currentTimeInSeconds > refreshTokenExpiryDate) {
    return true;
  }
  return false;
};

export function handlePartnerIntegratedChannelReauth(partnerNickNameID) {
  window.open(
    `${window.location.origin}/connect/${
      partnerNickNameID.split('-')[0]
    }?nickNameID=${partnerNickNameID}&isAccountReauthentication=true`,
    '_self'
  );
}

export const apiBackfillDuration = {
  lazada: 12,
  shopee: 12,
  shopify: 18,
  tokopedia: 12,
  magento: 12,
  woocommerce: 12,
  tiktok: 12,
  blibli: 12,
  zalora: 12,
  amazon: 3,
  amazonvendorcentral: 3,
  bukalapak: 18,
  salesforce: 12,
  flipkart: 12,
  myntra: 12,
  myntrasjit: 12,
  nykaa: 12,
  ajio: 12,
  facebookads: 18,
  googleads: 18,
  tiktokads: 12,
  googleanalytics: 12,
  lazadaads: 12,
  meesho: 3,
  tatacliq: 3
};

export const chromeExtensionBackfillDuration = {
  lazada: 1,
  shopee: 2,
  tokopedia: 2,
  amazon: 2
};

export const includeCountryMap = {}; //tokopediaShop: ['ID']
export const excludeCountryMap = {}; // tiktok: ['ID']
